import MAccordion, { accordionClasses } from "@mui/material/Accordion";
import MAccordionActions from "@mui/material/AccordionActions";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { Send2 } from "iconsax-react";

export const ContainerItem = styled("div")<{ isDraggingOver?: boolean }>(({ isDraggingOver }) => ({
  borderRadius: "4px",
  background: isDraggingOver ? colors.blue100 : colors.white,
  marginBottom: "8px",
  padding: "8px 16px",
  width: "368px",
  minHeight: "40px",
}));

export const Accordion = styled(MAccordion)(() => ({
  borderRadius: "12px !important",
  "&:before": {
    display: "none",
  },
  [`&.${accordionClasses.root}`]: {
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
  },
}));

export const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "8px 12px !important",
  color: "#475467",
  fontWeight: 600,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0.15px",
  height: "52px",

  [`&.${accordionSummaryClasses.root}`]: {
    minHeight: "auto !important",
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: "0 !important",
    display: "flex",
    alignItems: "center",
  },
}));

export const AccordionDetails = styled(MAccordionDetails)(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "8px !important",
  backgroundColor: colors.gray100,
  gap: "8px",
}));

export const AccordionActions = styled(MAccordionActions)(() => ({
  display: "flex",
  justifyContent: "space-between",
  "& > div": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    padding: 8,
  },
}));

export const FooterInfoIcon = styled("div")({
  display: "flex",
});

export const UnpublishTaskIcon = styled(Send2)({
  transform: "rotate(180deg)",
});

export const PublishTaskIcon = styled(Send2)({});

export const StorageBoxSlotSingleUseAdd = styled("div")({
  maxWidth: "38px",
  borderLeft: `1px solid ${colors.gray200}`,
  position: "relative",
  marginTop: "2px",
  marginBottom: "2px",
  marginRight: "2px",
  padding: "2px 0px",
});

export const PlaceholderContent = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "draggedItemHeight";
  },
})<{ draggedItemHeight?: number }>(({ draggedItemHeight }) => ({
  height: draggedItemHeight || 0,
}));

export const ResourceWrapper = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isDragging" && propName !== "cursor";
  },
})<{ isDragging?: boolean; cursor?: string }>(({ isDragging, cursor }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  opacity: isDragging ? 0.5 : 1,
  cursor,
}));

export const Title = styled("div")({
  display: "flex",
  flex: 1,
});

export const StatusLabel = styled("div")({
  color: colors.gray400,
  marginLeft: "4px",
  marginRight: "12px",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
});

export const TeamExtraInfo = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 2,
  "& span": {
    fontWeight: 400,
  },
});
